import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

const CustomerQuizHistory = ({ data }) => {

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const navigate = useNavigate()
    
    const { id } = useParams()

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.thumbnail || rowData?.quizName ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", cursor:'pointer' }} onClick={() => {navigate(`/customers/orders/${id}/quiz/${rowData?.quizId}/results/${rowData.attemptId}`)}} >
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/${rowData?.thumbnail}`}
                        alt=""
                        style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = "/img/placeholder-image.jpg"
                        }}
                    />
                    {rowData?.quizName}
                </div>
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.status === 'submitted' ? 'bg-success' : 'bg-danger'} `}>
                {rowData.status}
            </span>
        );
    };
    
    const zonNameBodyTemplate = (rowData) => {
        return (
            <p style={{color: (rowData?.type) === 'red' && '#DC2626' || (rowData?.type) === 'yellow' && '#D97706' || (rowData?.type) === 'green' && '#059669',}}>
                {rowData.zoneName}
            </p>
        );
    };
    
    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

  return (
    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={data} tableStyle={{ minWidth: '50rem' }} >
        <Column body={serialNoTemplate} header='S.NO' />
        <Column sortable header='Name' body={imageBodyTemplate} field='quizName' /> 
        <Column sortable header='Start time' field='startedAt' body={(rowData) => {
                const date = new Date(rowData.startedAt);
                return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
            }} />
        <Column sortable header='Status' body={statusBodyTemplate} />
        <Column sortable header='Total Score' field='totalScore' />
        <Column sortable header='Score Result' body={zonNameBodyTemplate} field='zoneName' />
    </DataTable>
  )
}

export default CustomerQuizHistory